import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HelpersService } from '../../../../../../../services/helpers.service';
import { RentalsService } from '../../../../../../../services/rentals.service';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

@Component({
  selector: 'app-add-edit-rental-override-store-time',
  templateUrl: './add-edit-rental-override-store-time.component.html',
  styleUrls: ['./add-edit-rental-override-store-time.component.scss'],
})
export class AddEditRentalOverrideStoreTimeComponent implements OnInit {
  @Input() data;
  @Input() configuration;
  @Output() close = new EventEmitter();
  public saving: boolean = false;
  public countryData: any = {};
  public minDate: Date = new Date();

  constructor(
    private rentalsService: RentalsService,
    private helpersService: HelpersService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.countryData = this.helpersService.getCountryData();
    if (this.data.id) {
      this.data.date = moment(this.data.date).toDate();
      if (this.data.isWorking) {
        this.data.startTime = moment(
          '1970-01-01T' + this.data.startTime,
        ).toDate();
        this.data.endTime = moment('1970-01-01T' + this.data.endTime).toDate();
      }
    } else {
      this.data.startTime = moment('1970-01-01T09:00:00').toDate();
      this.data.endTime = moment('1970-01-01T17:00:00').toDate();
    }
  }

  dayChanged() {
    console.log(this.data);
  }

  valid() {
    return (
      this.data.date &&
      (!this.data.isWorking ||
        (this.data.isWorking &&
          this.data.startTime &&
          this.data.endTime &&
          this.data.endTime > this.data.startTime))
    );
  }

  save() {
    var data = {
      ...this.data,
      date: moment(this.data.date).format('YYYY-MM-DDT00:00:00'),
      startTime: this.data.isWorking
        ? moment(this.data.startTime).format('HH:mm')
        : null,
      endTime: this.data.isWorking
        ? moment(this.data.endTime).format('HH:mm')
        : null,
    };

    this.saving = true;
    this.rentalsService.addOverrideStoreTime(data).subscribe(
      (res) => {
        this.saving = false;
        this.close.emit(res);
      },
      (err) => {
        this.saving = false;
      },
    );
  }

  setDefaultStartTime() {
    if (
      this.data.isWorking &&
      (this.data.startTime === null || this.data.startTime === undefined)
    ) {
      this.data.startTime = moment('1970-01-01T09:00:00').toDate();
    }
  }

  setDefaultEndTime() {
    if (
      this.data.isWorking &&
      (this.data.endTime === null || this.data.endTime === undefined)
    ) {
      this.data.endTime = moment('1970-01-01T17:00:00').toDate();
    }
  }
}
